export const defaultStyle = {
    wrapper: "bg-beige",
    container: "section-wrapper pb-[120px]",
    headline: "headline2 lg:mb-[10px]",
    ctaWrapper: "flex justify-center mt-[30px]",
    cta: "button button-secondary w-full max-w-[240px]",
}
